import React from 'react';
import {
  Box,
  IconButton,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { StyledTableContent, StyledTableRow } from 'shared/ui/Table/ui/StyledTableContent';
import { ColumnConfigType } from 'shared/types';

type DataTableSwitchType<DataType> = {
  title: string;
  data: DataType[];
  columnConfig: ColumnConfigType<DataType>[];
  deleteIcon?: boolean;
  handleDrawerDelete?: (data: DataType, variant: string, title: string) => void;
  variantDrawer?: string;
  titleDrawer?: string;
  emptyListTitle?: string;
  onRowClick?: (data: DataType) => void;
  style?: React.CSSProperties;
};

export const DataTableSwitch = <DataType,>({
  title,
  data,
  columnConfig,
  deleteIcon,
  handleDrawerDelete,
  onRowClick,
  variantDrawer = '',
  titleDrawer = '',
  emptyListTitle = 'Нет данных для отображения',
  style,
}: DataTableSwitchType<DataType>) => (
  <div style={style}>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Typography variant="h5">{title}</Typography>
    </div>
    {data && data.length > 0 ? (
      <StyledTableContent>
        <Box
          style={{
            marginTop: '12px',
          }}
        >
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {columnConfig.map((column, index) => (
                    <TableCell
                      key={index}
                      style={{ width: column.width }}
                    >
                      {column.name}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((data, idx: number) => (
                  <StyledTableRow
                    hover
                    onClick={() => onRowClick && onRowClick(data)}
                    key={idx}
                  >
                    {columnConfig.map((column, idx) => (
                      <TableCell
                        key={idx}
                        style={{ width: column.width }}
                      >
                        {typeof data[column.dataFieldName] === 'boolean' ? (
                          <Switch checked={data[column.dataFieldName] as boolean} />
                        ) : (
                          (data[column.dataFieldName] as React.ReactNode)
                        )}
                      </TableCell>
                    ))}
                    {deleteIcon && (
                      <TableCell>
                        <IconButton
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDrawerDelete?.(data, variantDrawer, titleDrawer);
                          }}
                        >
                          <CloseOutlinedIcon />
                        </IconButton>
                      </TableCell>
                    )}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </StyledTableContent>
    ) : (
      <Box marginTop="30px">
        <Typography>{emptyListTitle}</Typography>
      </Box>
    )}
  </div>
);
